import { createContext, useContext, useState } from "react";

const AdditionalExperienceContext = createContext(null);

export const useAdditionalExperience = () => {
  const ctx = useContext(AdditionalExperienceContext);
  if (!ctx) {
    throw new Error(
      "useAdditionalExperience must be used within AdditionalExperienceProvider"
    );
  }
  return ctx;
};

export const AdditionalExperienceProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [bookingId, setBookingId] = useState(null);
  const [programId, setProgramId] = useState(null);

  const openModal = (payload) => {
    let normalizedBookingId = null;
    let normalizedProgramId = null;

    // Backward compatible (string bookingId)
    if (typeof payload === "string") {
      normalizedBookingId = payload;
    }
    // New object payload { bookingId, programId }
    else if (payload && typeof payload === "object") {
      normalizedBookingId = payload.bookingId ?? payload.value ?? null;
      normalizedProgramId = payload.programId ?? null;
    }

    setBookingId(normalizedBookingId);
    setProgramId(normalizedProgramId);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setBookingId(null);
    setProgramId(null);
  };

  return (
    <AdditionalExperienceContext.Provider
      value={{
        isOpen,
        bookingId,
        programId,
        openModal,
        closeModal,
      }}
    >
      {children}
    </AdditionalExperienceContext.Provider>
  );
};
